import { useNewEditTemplateCollectionContext } from "../../../context/NewEditTemplateCollectionContext"

export const useNewEditTemplateCollectionBody = () => {
    const {
        chargeDebtorsData
    } = useNewEditTemplateCollectionContext()
    return {
        chargeDebtorsData
    }
}